var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/attachment"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.8941 6.22743V9.19039C6.8941 9.50472 7.01116 9.80618 7.21953 10.0284C7.42791 10.2507 7.71052 10.3756 8.00521 10.3756C8.29989 10.3756 8.58251 10.2507 8.79088 10.0284C8.99926 9.80618 9.11632 9.50472 9.11632 9.19039V5.04225C9.11632 4.41358 8.88219 3.81067 8.46545 3.36614C8.0487 2.92161 7.48347 2.67188 6.8941 2.67188C6.30473 2.67188 5.7395 2.92161 5.32275 3.36614C4.906 3.81067 4.67188 4.41358 4.67188 5.04225V9.78299C4.67188 10.726 5.02306 11.6303 5.64819 12.2971C6.27331 12.9639 7.12115 13.3385 8.00521 13.3385C8.88926 13.3385 9.73711 12.9639 10.3622 12.2971C10.9874 11.6303 11.3385 10.726 11.3385 9.78299V3.85706",
    stroke: "#79808A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAttachment);
export default __webpack_public_path__ + "static/media/ic_attachment.c22dc5908ea71ecb44091dacd2274932.svg";
export { ForwardRef as ReactComponent };